<template>
  <div>
    <!-- crtItem:{{crtItem}} -->
    <van-sticky :offset-top="46">
      <div style="height: 70px; background-color: white; padding: 1rem 1rem 0 1rem">
        <div style="font-size: 1.5rem">{{ params.storeid }}</div>
        <div v-if="!isOpenTime()">線上點餐時間:{{ params.timeb }}~{{ params.timee }}</div>
        <div v-else>
          <el-tooltip effect="dark" content="備餐時間" placement="bottom">
            <span style="line-height: 1.5rem">
              <van-icon name="clock-o" />{{ params.time }}
            </span>
          </el-tooltip>
        </div>
      </div>
    </van-sticky>

    <div class="line"></div>
    <van-collapse v-model="activeNames" :border="false">
      <van-collapse-item name="1">
        <template #title>
          <div style="font-size: 1rem">營業時間：{{ getTimeDscp() }}</div>
        </template>
        <div
          style="line-height: 1.5rem; font-size: 0.9rem; color: #333"
          v-for="day in params.WeekOpenTime"
          :key="day.weekday"
        >
          <span style="margin-right: 0.5rem">星期{{ cweekday[day.weekday] }}</span>
          <span style="margin-right: 1rem" v-for="ot in day.openTime" :key="ot.timeb">
            {{ ot.timeb }} ~ {{ ot.timee }}
          </span>
          <span style="color: orangered" v-if="day.openTime.length == 0"> 公休日 </span>
        </div>
      </van-collapse-item>
    </van-collapse>

    <div class="line"></div>
    <div style="padding: 1rem">
      <div>餐廳資訊</div>
      <!-- {{ now }} -->

      <!-- {{ menuitem.length }} -->
      <div v-html="params.info"></div>
    </div>

    <!-- <span style="font-size: 2rem">{{ menuitem }}</span> -->

    <van-tabs :offset-top="126" background="#EEE" scrollspy sticky>
      <!-- <van-tabs
      :offset-top="132"
      background="#EEE"
      sticky
      @click="beforeChange"
      ref="tabs"
    >    -->
      <van-tab v-for="mt in menutype" :key="mt.TypeNo" :title="mt.TypeName">
        <div
          style="margin: 1rem; font-size: 1.2rem; font-weight: bold; text-align: center"
        >
          {{ mt.TypeName }}
        </div>

        <van-grid :center="false" :clickable="true" :column-num="1">
          <van-grid-item
            v-for="mi in getMenuByTypeNo(mt.TypeNo)"
            :key="mi.ItemName"
            @click="showItem(mi)"
          >
            <van-row v-if="mi.Price1 >= 0">
              <van-col span="18" align="left">
                <div style="font-size: 1.1rem">{{ dscpItemName(mi) }}</div>
                <div class="van-multi-ellipsis--l2" style="color: #aaa">
                  <span v-if="!params.ItemNameUseRemark">
                    <span v-html="mi.Remark"></span>
                  </span>
                </div>
                <div style="color: orangered">${{ mi.Price1 }}</div>
                <div style="margin-top: 0.4rem">
                  <van-tag
                    type="primary"
                    color="#666"
                    round
                    size="large"
                    v-if="mi.KPtype.substr(0, 1) == '-'"
                  >
                    已售完
                  </van-tag>
                </div>
              </van-col>
              <van-col span="6">
                <div style="height: 6rem">
                  <el-image :src="mi.ImgFile" fit="full" lazy>
                    <div slot="error"></div>
                  </el-image>
                </div>
              </van-col>
            </van-row>
          </van-grid-item>
        </van-grid>
      </van-tab>
    </van-tabs>
    <!-- {{ menuitem }} -->
    <!-- frmItem -->
    <van-popup v-model="frmItem.visible" position="top" id="m1">
      <van-nav-bar
        :title="dscpItemName(crtItem)"
        left-text="返回"
        left-arrow
        fixed
        placeholder
        @click-left="closeItem()"
      />
      <Item :item="crtItem" :collapse="collapse" :params="params" />
      <van-tabbar v-model="active" placeholder>
        <van-button
          type="info"
          size="large"
          :disabled="isStopSale(crtItem) || !isOpenTime()"
          @click="addItem()"
        >
          <span v-if="!isOpenTime()">現在非營業時間 </span>
          <span v-else>
            <span v-if="!isStopSale(crtItem)">
              加入 {{ crtItem.Qty }} 份 , 金額${{ crtItem.Qty * getItemPrice(crtItem) }}
            </span>
            <span v-else> 此項目已售完 </span>
          </span>
        </van-button>
      </van-tabbar>
    </van-popup>
  </div>
</template>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
.van-popup {
  height: 100%;
}
.el-button {
  width: 98%;
  margin: 1%;
}
h2 {
  text-align: center;
}
.line {
  height: 0.5rem;
  background-color: #eee;
}
.carbox {
  border-radius: 40px 0px 0px 40px;
  background: rgba(200, 200, 200, 0.5);
  float: right;
  height: 4rem;
  width: 5rem;
  border: 2px 0 2px 0 #666 solid;
}
</style>

<script>
import menutype from "./json/menutype.json";
import menuitem from "./json/menuitem.json";
import menunote from "./json/menunote.json";
import Item from "@/components/Item.vue";
export default {
  name: "Menu",
  components: {
    Item,
  },
  props: {
    msg: String,
    orders: Object,
    params: Object,
    now: Object,
    // menutype: Object,
    // menuitem: Object,
  },
  data() {
    return {
      active: 0,
      menutype: menutype,
      menuitem: menuitem,
      menunote: menunote,
      frmItem: { visible: false },
      crtItem: [],
      // collapse: [],
      user: [],
      itemnote: [],
      test: [],
      cweekday: ["日", "一", "二", "三", "四", "五", "六"],
      activeNames: [1],
      collapse: [],
    };
  },
  beforeMount: function () {
    this.init();
  },
  mounted() {
    // this.$refs.tabs.toggle();
  },
  methods: {
    init() {
      var app = this;
      app.$http
        .get("./menutype")
        .then((response) => {
          app.menutype = response.data;
        })
        .catch(function (error) {
          console.log(error);
          app.menutype = menutype;
        });
      app.$http
        .get("./menuitems1")
        .then((response) => {
          app.menuitem = response.data;
          // app.menuitem = [];
        })
        .catch(function (error) {
          console.log(error);
          app.menuitem = menuitem;
        });
      // app.$http
      //   .get("./menunote")
      //   .then((response) => {
      //     app.menunote = response.data;
      //   })
      //   .catch(function (error) {
      //     console.log(error);
      //     app.menunote = menunote;
      //   });
    },
    getMenuByTypeNo(pTypeNo) {
      let data = [];
      for (let i = 0; i < this.menuitem.length; i++) {
        if (this.menuitem[i].TypeNo == pTypeNo) {
          data.push(this.menuitem[i]);
        } else {
          if (data.length > 0) {
            break;
          }
        }
      }
      return data;
    },
    showmsg: function (pMsg) {
      this.$message({
        message: pMsg,
        duration: 1800,
        type: "success",
        showClose: true,
      });
    },
    showItem: function (obj) {
      if (obj.KPtype.substr(0, 1) == "-") {
        this.$dialog.alert({
          message: "已售完",
        });
        return;
      }
      var app = this;
      var menuitems2 = [];
      app.collapse = [0, 1, 2, 3, 4, 5, 6, 7, 8, 9, "note"];
      app.$http
        .get("./menuitemss", { params: { itemname: obj.ItemName, typeno: obj.TypeNo } })
        .then((response) => {
          menuitems2 = response.data;
          menuitems2.showmore = false;
          app.crtItem = menuitems2;
          app.frmItem.visible = true;
        })
        .catch(function (error) {
          console.log(error);
          app.$dialog.alert({
            message: error,
          });
        });
    },
    // getItemNote: function (obj) {
    //   let data = [];
    //   let an = [];
    //   for (let i = 0; i < this.menunote.length; i++) {
    //     if (this.menunote[i].Typeno == obj.TypeNo) {
    //       this.menunote[i].value = "";
    //       data.push(this.menunote[i]);
    //     }

    //     if (this.menunote[i].Remark == obj.ItemName) {
    //       an.push(this.menunote[i]);
    //     }
    //   }

    //   if (an.length > 0) {
    //     data = an;
    //   }
    //   return data;
    // },
    getPrices: function (obj) {
      //取得品項價別清單
      let data = [];

      for (let i = 0; i < this.menutype.length; i++) {
        if (this.menutype[i].TypeNo == obj.TypeNo) {
          var row = {};

          if (obj.Price1 != "0.01") {
            row = {};
            row.PriceCap = this.menutype[i].Price1Cap;
            row.Price = obj.Price1;
            data.push(row);
          }

          if (Number(obj.Price2) != 0.01 && Number(obj.Price2) > 0) {
            row = {};
            row.PriceCap = this.menutype[i].Price2Cap;
            row.Price = obj.Price2;
            data.push(row);
          }

          if (Number(obj.Price3) != 0.01 && Number(obj.Price3) > 0) {
            row = {};
            row.PriceCap = this.menutype[i].Price3Cap;
            row.Price = obj.Price3;
            data.push(row);
          }
          break;
        }
      }
      return data;
    },

    // getS2: function (obj, callback) {
    //   //取得品項附餐項目
    //   let data = [];
    //   let level = []; //附餐階層列表
    //   let tmp = [];

    //   //取得階層列表  ex: [ "LV1_升級套餐", "LV2_主食加點", "LV3_甜點加點", "LV4_湯品加點" ]
    //   var menuitems2 = [];
    //   // menuitems2 = [{"TypeNo":"10161","ItemNo":"1","ItemName":"原味蔬菜-","ItemType":"A1","Price1":"0","Price2":"0.01","Price3":"0","KPtype":"K1","CtrlFlag":"LV1","ItemCode":"","ImgFile":"","Remark":"單人鍋","AvailTime":"","OpenCode":"N"},{"TypeNo":"10161","ItemNo":"2","ItemName":"昆布柴魚-","ItemType":"A1","Price1":"30","Price2":"0.01","Price3":"0","KPtype":"K1","CtrlFlag":"LV1","ItemCode":"","ImgFile":"","Remark":"單人鍋","AvailTime":"","OpenCode":"N"},{"TypeNo":"10161","ItemNo":"3","ItemName":"壽喜鍋-","ItemType":"A1","Price1":"50","Price2":"0.01","Price3":"0","KPtype":"K1","CtrlFlag":"LV1","ItemCode":"","ImgFile":"","Remark":"單人鍋","AvailTime":"","OpenCode":"N"},{"TypeNo":"10161","ItemNo":"4","ItemName":"辣味噌-","ItemType":"A1","Price1":"50","Price2":"0.01","Price3":"0","KPtype":"K1","CtrlFlag":"LV1","ItemCode":"","ImgFile":"","Remark":"單人鍋","AvailTime":"","OpenCode":"N"},{"TypeNo":"10161","ItemNo":"5","ItemName":"韓式辣味-","ItemType":"A1","Price1":"50","Price2":"0.01","Price3":"0","KPtype":"K1","CtrlFlag":"LV1","ItemCode":"","ImgFile":"","Remark":"單人鍋","AvailTime":"","OpenCode":"N"},{"TypeNo":"10161","ItemNo":"6","ItemName":"酸白菜-","ItemType":"A1","Price1":"60","Price2":"0.01","Price3":"0","KPtype":"K1","CtrlFlag":"LV1","ItemCode":"","ImgFile":"","Remark":"單人鍋","AvailTime":"","OpenCode":"N"},{"TypeNo":"10161","ItemNo":"7","ItemName":"養生蒙古-","ItemType":"A1","Price1":"60","Price2":"0.01","Price3":"0","KPtype":"K1","CtrlFlag":"LV1","ItemCode":"","ImgFile":"","Remark":"單人鍋","AvailTime":"","OpenCode":"N"},{"TypeNo":"10161","ItemNo":"8","ItemName":"泰式酸辣-","ItemType":"A1","Price1":"60","Price2":"0.01","Price3":"0","KPtype":"K1","CtrlFlag":"LV1","ItemCode":"","ImgFile":"","Remark":"單人鍋","AvailTime":"","OpenCode":"N"},{"TypeNo":"10161","ItemNo":"9","ItemName":"冬蟲夏草-","ItemType":"A1","Price1":"70","Price2":"0.01","Price3":"0","KPtype":"K1","CtrlFlag":"LV1","ItemCode":"","ImgFile":"","Remark":"單人鍋","AvailTime":"","OpenCode":"N"},{"TypeNo":"10161","ItemNo":"10","ItemName":"藥膳何首烏-","ItemType":"A1","Price1":"70","Price2":"0.01","Price3":"0","KPtype":"K1","CtrlFlag":"LV1","ItemCode":"","ImgFile":"","Remark":"單人鍋","AvailTime":"","OpenCode":"N"},{"TypeNo":"10161","ItemNo":"11","ItemName":"咖哩湯-","ItemType":"A1","Price1":"70","Price2":"0.01","Price3":"0","KPtype":"K1","CtrlFlag":"LV1","ItemCode":"","ImgFile":"","Remark":"單人鍋","AvailTime":"","OpenCode":"N"},{"TypeNo":"10161","ItemNo":"12","ItemName":"麻辣湯-","ItemType":"A1","Price1":"79","Price2":"0.01","Price3":"0","KPtype":"K1","CtrlFlag":"LV1","ItemCode":"","ImgFile":"","Remark":"單人鍋","AvailTime":"","OpenCode":"N"},{"TypeNo":"10161","ItemNo":"13","ItemName":"茄汁牛奶-","ItemType":"A1","Price1":"80","Price2":"0.01","Price3":"0","KPtype":"K1","CtrlFlag":"LV1","ItemCode":"","ImgFile":"","Remark":"單人鍋","AvailTime":"","OpenCode":"N"},{"TypeNo":"10161","ItemNo":"14","ItemName":"墨魚牛奶-","ItemType":"A1","Price1":"80","Price2":"0.01","Price3":"0","KPtype":"K1","CtrlFlag":"LV1","ItemCode":"","ImgFile":"","Remark":"單人鍋","AvailTime":"","OpenCode":"N"},{"TypeNo":"10161","ItemNo":"15","ItemName":"麻辣牛奶-","ItemType":"A1","Price1":"89","Price2":"0.01","Price3":"0","KPtype":"K1","CtrlFlag":"LV1","ItemCode":"","ImgFile":"","Remark":"單人鍋","AvailTime":"","OpenCode":"N"},{"TypeNo":"10161","ItemNo":"16","ItemName":"牛奶-","ItemType":"A1","Price1":"89","Price2":"0.01","Price3":"0","KPtype":"K1","CtrlFlag":"LV1","ItemCode":"","ImgFile":"","Remark":"單人鍋","AvailTime":"","OpenCode":"N"},{"TypeNo":"10161","ItemNo":"19","ItemName":"白開水-","ItemType":"A1","Price1":"0","Price2":"0.01","Price3":"0","KPtype":"K1","CtrlFlag":"LV1","ItemCode":"","ImgFile":"","Remark":"單人鍋","AvailTime":"","OpenCode":"N"},{"TypeNo":"10161","ItemNo":"20","ItemName":"辣味鮮蟹-","ItemType":"A1","Price1":"129","Price2":"0.01","Price3":"0","KPtype":"K1","CtrlFlag":"LV1","ItemCode":"","ImgFile":"","Remark":"單人鍋","AvailTime":"","OpenCode":"N"},{"TypeNo":"10161","ItemNo":"21","ItemName":"原味鮮蟹-","ItemType":"A1","Price1":"129","Price2":"0.01","Price3":"0","KPtype":"K1","CtrlFlag":"LV1","ItemCode":"","ImgFile":"","Remark":"單人鍋","AvailTime":"","OpenCode":"N"}];
    //   var app = this;
    //   app.$http
    //     .get("./menuitems2", { params: { itemname: obj.ItemName } })
    //     .then((response) => {
    //       menuitems2 = response.data;
    //       // alert(menuitems2.length);

    //       for (let i = 0; i < menuitems2.length; i++) {
    //         if (menuitems2[i].Remark == obj.ItemName) {
    //           let exist = false;
    //           tmp.push(menuitems2[i]);
    //           for (let j = 0; j < level.length; j++) {
    //             if (level[j] == menuitems2[i].CtrlFlag) {
    //               exist = true;
    //               break;
    //             }
    //           }
    //           if (!exist) {
    //             level.push(menuitems2[i].CtrlFlag);
    //             level.sort();
    //           }
    //         }
    //       }

    //       let arr = obj.CtrlFlag.split("/");

    //       for (let i = 0; i < level.length; i++) {
    //         let row = {};
    //         row.lv = level[i];
    //         row.count = 0;
    //         row.lock = false;
    //         row.value = false;

    //         if (i < arr.length) {
    //           row.count = arr[i];
    //           if (row.count.substr(-1) == "=") {
    //             row.lock = true;
    //             row.count = row.count.substr(0, 1);
    //           }
    //         }
    //         row.items = [];
    //         for (let j = 0; j < tmp.length; j++) {
    //           if (tmp[j].CtrlFlag == level[i]) {
    //             let item = {};
    //             item.ItemName = tmp[j].ItemName;
    //             item.Level = tmp[j].CtrlFlag;
    //             item.Price = tmp[j].Price1;
    //             item.KPtype = tmp[j].KPtype;
    //             item.ItemType = tmp[j].ItemType;
    //             if (item.ItemType == "SS") {
    //               item.CtrlFlag = app.getS1CtrlFlag(item.ItemName);
    //             }
    //             item.value = false;

    //             if (item.ItemType.substr(0, 1) == "Q") {
    //               var qty = Number(item.ItemType.substr(1));
    //               if (qty == undefined) {
    //                 qty = 0;
    //               }
    //               if (item.KPtype.substr(0, 1) == "-") {
    //                 qty = 0;
    //               }
    //               item.value = qty;
    //             } else if (item.ItemType.substr(0, 1) == "V") {
    //               item.value = true;
    //               if (item.KPtype.substr(0, 1) == "-") {
    //                 item.value = false;
    //               }
    //             }

    //             row.items.push(item);
    //           }
    //         }
    //         data.push(row);
    //       }
    //       // alert("return data:" + JSON.stringify(data));
    //       // return data;
    //       callback(null, data);
    //     })
    //     .catch(function (error) {
    //       console.log(error);
    //       app.$dialog.alert({
    //         message: error,
    //       });
    //       callback(error);
    //     });
    // },
    getS1CtrlFlag: function (pItemName) {
      var ctrlflag = "";
      for (let i = 0; i < this.menuitem.length; i++) {
        if (this.menuitem[i].ItemName == pItemName && this.menuitem[i].ItemType == "S1") {
          ctrlflag = this.menuitem[i].CtrlFlag;
          // alert(pItemName + ",ctrlflag:" + ctrlflag);
          break;
        }
      }
      return ctrlflag;
    },
    addItem: function () {
      var app = this;
      if (app.checkData()) {
        app.$http
          .post("./addItem", { item: this.crtItem })
          .then((response) => {
            console.log(response.data);
            // this.showmsg("加入項目");
            this.orders.qty = response.data;
            // alert(response.data);
            this.orders.msg = response.data;
            this.closeItem();
          })
          .catch(function (error) {
            app.$dialog.alert({
              message: error,
            });
          });
      } else {
        app.$dialog.alert({
          message: "附餐數量錯誤",
        });
      }
    },
    closeItem: function () {
      this.itemnote = [];
      this.crtItem = [];
      this.frmItem.visible = false;
      this.scrollToTop();
    },
    getItemPrice: function (item) {
      if (item == undefined || item.length == 0) {
        return 0;
      }
      if (item.Prices == undefined) {
        return 0;
      }
      if (item.SelectedPrice == undefined) {
        return 0;
      }
      var Price = Number(item.Price1);
      Price = Number(item.Prices[item.SelectedPrice].Price);
      // Price = Number(item.Prices[item.SelectedPrice].Price);
      // var PriceCap = item.Prices[item.SelectedPrice].PriceCap;
      var notes = item.Notes;
      if (notes != undefined) {
        for (let i = 0; i < notes.length; i++) {
          if (notes[i].value) {
            if (Number(notes[i].Remark > 0)) {
              Price += Number(notes[i].Remark);
            }
          }
        }
      }

      var s2 = item.S2;
      if (s2 == undefined) {
        return Price;
      }

      for (let i = 0; i < s2.length; i++) {
        console.log(i);
        var items = s2[i].items;
        for (let j = 0; j < items.length; j++) {
          if (items[j].value) {
            let qty = Number(items[j].value);
            Price += Number(items[j].Price) * qty;
            if (items[j].ItemType == "SS") {
              var s3 = items[j].S2;
              for (let k = 0; k < s3.length; k++) {
                var s3items = s3[k].items;
                for (let l = 0; l < s3items.length; l++) {
                  if (s3items[l].value) {
                    let s3qty = Number(s3items[l].value);
                    Price += Number(s3items[l].Price) * s3qty;
                  }
                }
              }
            }
          }
        }
      }
      return Price;
    },
    checkData: function () {
      var s2 = this.crtItem.S2;
      var checkData = false;
      for (let i = 0; i < s2.length; i++) {
        var count = s2[i].count;
        var items = s2[i].items;
        var lock = s2[i].lock;
        var selectedCount = this.getS2SelectedCount(items);
        if (lock) {
          if (count != selectedCount) {
            checkData = false;
            return checkData;
          }
        } else {
          // alert(count + "," + selectedCount);
          if (Number(count) != 0) {
            if (Number(count) < selectedCount) {
              checkData = false;
              return checkData;
            }
          }
        }
      }
      checkData = true;
      return checkData;
    },
    getS2SelectedCount(items) {
      let count = 0;
      for (let i = 0; i < items.length; i++) {
        if (items[i].value) {
          count += Number(items[i].value);
        }
      }
      return count;
    },
    isStopSale: function (obj) {
      if (obj.length == 0 || obj == undefined) {
        return true;
      }
      var kptype = obj.KPtype;
      if (kptype.substr(0, 1) == "-") {
        return true;
      }

      return false;
    },

    scrollToTop() {
      var m1 = document.getElementById("m1");
      if (m1 != null) {
        m1.scrollTo(0, 0);
      }
    },

    isOpenTime: function () {
      var timeb = {};
      var timee = {};

      if (this.params.timeb == undefined) {
        return true;
      }
      timeb.hh = Number(this.params.timeb.substr(0, 2));
      timeb.mm = Number(this.params.timeb.substr(3, 2));
      timee.hh = Number(this.params.timee.substr(0, 2));
      timee.mm = Number(this.params.timee.substr(3, 2));

      if (this.now.hh < timeb.hh) {
        return false;
      }

      if (this.now.hh > timee.hh) {
        return false;
      }

      if (this.now.hh == timeb.hh) {
        if (this.now.mm < timeb.mm) {
          return false;
        }
      }

      if (this.now.hh == timee.hh) {
        if (this.now.mm >= timee.mm) {
          return false;
        }
      }
      return true;
    },
    dscpItemName(obj) {
      var itemname = obj.ItemName;
      if (this.params.ItemNameUseRemark) {
        if (obj.Remark != "" && obj.Remark != "AN") {
          itemname = obj.Remark;
        }
      }
      return itemname;
    },

    getTimeDscp: function () {
      var day = {};
      if (this.params.WeekOpenTime.length == 7) {
        day = this.params.WeekOpenTime[0];
      }

      var isOpen = false;
      var timedscp = "";
      for (let i = 0; i < day.openTime.length; i++) {
        var openTime = day.openTime[i];
        var timeb = openTime.timeb;
        var timee = openTime.timee;
        var time = this.now.time;
        timedscp += timeb + "-" + timee + " ";
        if (this.isVailTime(time, timeb, timee)) {
          isOpen = true;
        }
      }
      if (isOpen) {
        timedscp = "營業中 " + timedscp;
      }

      return timedscp;
    },
    isVailTime: function (pTime, pTimeb, pTimee) {
      var hh = Number(pTime.substr(0, 2));
      var mm = Number(pTime.substr(3, 2));
      var timeb = {};
      var timee = {};
      timeb.hh = Number(pTimeb.substr(0, 2));
      timeb.mm = Number(pTimeb.substr(3, 2));
      timee.hh = Number(pTimee.substr(0, 2));
      timee.mm = Number(pTimee.substr(3, 2));
      if (timee.hh > timeb.hh) {
        //沒有跨日
        if (hh < timeb.hh) {
          return false;
        }
        if (hh > timee.hh) {
          return false;
        }
        if (hh == timeb.hh) {
          if (mm < timeb.mm) {
            return false;
          }
        }
        if (hh == timee.hh) {
          if (mm > timee.mm) {
            return false;
          }
        }
      } else if (timee.hh < timeb.hh) {
        //跨日營業
        if (hh < timeb.hh && hh > timee.hh) {
          return false;
        }
        if (hh > timee.hh && hh < timeb.hh) {
          return false;
        }
        if (hh == timeb.hh) {
          if (mm < timeb.mm) {
            return false;
          }
        }
        if (hh == timee.hh) {
          if (mm > timee.mm) {
            return false;
          }
        }
      }
      return true;
    },
    selectMenuType(name, title) {
      // var m3 = document.getElementById("m3");
      // m3.isFixed = true;
      var app = this;
      console.log(title);
      // alert(name + "," + title + "," + this.menutype[name].TypeNo);
      let url = "./menuitems1?typeno=" + this.menutype[name].TypeNo;
      let data = [];
      app.$http
        .get(url)
        .then((response) => {
          data = response.data;
          // alert(JSON.stringify(data));
          app.menuitem = data;
          // m3.isFixed = true;
        })
        .catch(function (error) {
          console.log(error);
          app.menuitem = [];
        });
    },

    beforeChange(index, name) {
      console.log(index + "," + name);
      var app = this;
      // app.menuitem = [];
      // 返回 false 表示阻止此次切换
      // alert("beforeChange,index=" + index + "," + this.menutype[index].TypeName);
      // if (index === 1) {
      //   return false;
      // }

      let url = "./menuitems1?typeno=" + this.menutype[index].TypeNo;

      // 返回 Promise 来执行异步逻辑
      return new Promise((resolve) => {
        // 在 resolve 函数中返回 true 或 false
        app.$http
          .get(url)
          .then((response) => {
            let data = response.data;
            // alert(JSON.stringify(data));
            app.menuitem = data;
            // this.$refs.tabs.scrollTo(4);
            // this.$refs.tabs.scrollTo(300,300);
            // alert(app.$refs.tabs);
            resolve(true);
          })
          .catch(function (error) {
            console.log(error);
            app.menuitem = [];
          });
      });
    },
  },
};
</script>
